import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// eslint-disable-next-line import/no-unresolved
// import { TemporaryDrawer } from 'components/drawer/navDrawer';
// import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
// import Button from '@mui/material/Button';
// import DehazeIcon from '@mui/icons-material/Dehaze';

// import MenuItem from '@mui/material/MenuItem';
// eslint-disable-next-line import/no-unresolved
import { useDevice } from 'hooks/useResponsive';
import { Link, Typography } from '@mui/material';
// import HomeIcon from '@mui/icons-material/Home';
// import DriveEtaIcon from '@mui/icons-material/DriveEta';
// import SellIcon from '@mui/icons-material/Sell';
// import AirportShuttleRoundedIcon from '@mui/icons-material/AirportShuttleRounded';
// import CloseIcon from '@mui/icons-material/Close';
// import SearchSharpIcon from '@mui/icons-material/SearchSharp';

// eslint-disable-next-line import/no-unresolved
import { SpecialTemporaryDrawer } from 'components/drawer/specialNavDrawer';
import SpecialLogo from '../../components/logo/SpecialLogo';

const pages = [
  // { item: 'Home', link: '/home' },
  { item: 'Buy Used Car', link: '/allproducts' },
  { item: 'Sell Your Car', link: '/sell' },
  { item: 'Dream Car', link: '/dream' },
];

function SpecialHeader() {
  const { isMobile } = useDevice();

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: 'white',
        // backgroundColor: 'rgba(18, 18, 18, 0.7)',
        backdropFilter: 'blur(26.3px)',
        WebkitBackdropFilter: 'blur(26.3px)',
        boxShadow: 'none',
        p: { xs: 0, sm: 2 },
        px: { xs: 0, sm: 7 },
        pb: { xs: 1 },
        pt: { xs: 1 },
      }}
    >
      <Container maxWidth={isMobile ? 'lg' : ''}>
        <Toolbar
          disableGutters
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '25px',
            minHeight: '47px',
          }}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            width={isMobile ? '100%' : 'fit-content'}
          >
            <SpecialLogo />
            {/* {(location?.pathname === '/home' || location?.pathname === '/allproducts') && isMobile && (
              <Link href={'/search'} style={{ textDecoration: 'none' }}>
                <Grid>
                  <TextField
                    size="small"
                    placeholder="Search Your fav Car"
                    type="text"
                    className="custom-field-Header"
                    sx={{
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '16px',
                        '& fieldset': {
                          borderRadius: '16px',
                          borderColor: 'transparent', // remove border
                        },
                        '&:hover fieldset': {
                          borderColor: 'transparent', // no border on hover
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'transparent', // no border on focus
                        },
                        '& input::placeholder': {
                          color: '#FFFFFF99',
                          opacity: 1,
                        },
                      },
                    }}
                    InputProps={{
                      autoComplete: 'off',
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" sx={{ color: '#FFA800', transform: 'rotate(90deg)' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
              
                </Grid>
              </Link>
            )} */}
            {isMobile && <SpecialTemporaryDrawer />}
          </Box>

          {/* <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages?.map((page, key) => (
                <MenuItem key={key} onClick={handleCloseNavMenu}>
                  <Link to={page?.link} style={{ textDecoration: 'none', textAlign: 'center' }}>
                    <Typography textAlign="center" sx={{ color: 'black' }}>
                      {page?.item}
                    </Typography>
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box> */}

          <Box
            width={'100%'}
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'end',
              width: isMobile ? '100%' : 'fit-content',
            }}
          >
            {pages?.map((page, key) => (
              <Link
                key={key}
                // component={Link}
                href={page?.link}
                // onClick={handleCloseNavMenu}
                sx={{ my: 2, color: '#E3E3E3', display: 'flex', alignItems: 'center', mx: 3, textDecoration: 'none' }}
              >
                {/* {page?.item === 'Home' ? (
                  <HomeIcon fontSize="small" className="head-icon-color" />
                ) : page?.item === 'Buy' ? (
                  <AirportShuttleRoundedIcon fontSize="small" className="head-icon-color" />
                ) : page?.item === 'Sell' ? (
                  <SellIcon fontSize="small" className="head-icon-color" />
                ) : (
                  <DriveEtaIcon fontSize="small" className="head-icon-color" />
                )} */}
                <Typography
                  sx={{
                    padding: '3px 0px 0px 4px',
                    color: '#FFFFFFDE',
                    fontSize: '16px',
                    textShadow: '1px 1px 2px #000',
                  }}
                  fontWeight={600}
                >
                  {page?.item}
                </Typography>
              </Link>
            ))}
          </Box>
        </Toolbar>
        {/* {(location?.pathname === '/home' || location?.pathname === '/allproducts') && isMobile && (
          <Link href={'/search'} style={{ textDecoration: 'none' }}>
            <Grid mt={2}>
              <TextField
                placeholder="Search Your fav! 🚗"
                type="text"
                className="custom-field-sell"
                sx={{ border: '0px solid gray', borderRadius: '10px', width: '100%' }}
                InputProps={{ autoComplete: 'off' }}
              />
              <img
                src={`assets/images/Header/search.png`}
                alt=""
                style={{ position: 'absolute', top: 105, right: 30 }}
              />
            </Grid>
          </Link>
        )} */}
      </Container>
    </AppBar>
  );
}

export default SpecialHeader;
